import React, { useState } from 'react';
import styles from './WelcomeScreenStartForm.scss';
import { Button } from '@kaizen/button';
import RightArrow from '@kaizen/component-library/icons/arrow-right.icon.svg';
import { useData } from '../../hooks';
import { useMediaQuery, useRTL } from 'ca-hooks';
import { sendAmpliEvent } from '../../../../../../ampli/sendAmpliEvent';
import { SurveyStarted } from '../../../../../../ampli';
import { useIntl } from '@cultureamp/i18n-react-intl';

export interface WelcomeScreenStartFormProps {
  workingOveride?: boolean;
}

export const WelcomeScreenStartForm = ({
  workingOveride,
}: WelcomeScreenStartFormProps) => {
  const { aggregate_id, start_path, secret, welcome_screen_locale } = useData();
  const isRTL = useRTL(welcome_screen_locale.code);
  const [working, setWorking] = useState<boolean>(workingOveride || false);
  const desktop = useMediaQuery('(min-width:798px)');
  const { formatMessage } = useIntl();

  const startSurvey = async () => {
    const event = new SurveyStarted();
    sendAmpliEvent({ ...event, group_properties: { Survey: aggregate_id } });
    setWorking(true);
    try {
      const postObject: RequestInit = {
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        redirect: 'follow',
      };

      const requestObject: RequestInit = {
        ...postObject,
        ...(secret && {
          body: JSON.stringify({
            secret: secret,
          }),
        }),
      };

      const response = await fetch(start_path, requestObject);
      if (response.redirected) {
        window.location.href = response.url;
      }
    } catch (error: unknown) {
      if (error instanceof Error) {
        window.bugsnagClient.notify(error);
      }
    }
  };

  return (
    <div
      className={styles.WelcomeScreenStartFormContainer}
      dir={isRTL ? 'rtl' : 'ltr'}
    >
      <Button
        label={formatMessage({
          id: 'welcome_screen.form_label',
          defaultMessage: 'Take survey',
        })}
        primary
        icon={RightArrow}
        iconPosition="end"
        onClick={() => startSurvey()}
        workingLabel={formatMessage({
          id: 'welcome_screen.form_working_label',
          defaultMessage: 'Loading survey',
        })}
        working={working}
        fullWidth={!desktop}
      />
    </div>
  );
};
